// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryCardTsx from "./CanaryCard.tsx";

let make = CanaryCardTsx.CanaryCard;

let make$1 = CanaryCardTsx.CanaryCardHeader;

let Header = {
  make: make$1
};

let make$2 = CanaryCardTsx.CanaryCardTitle;

let Title = {
  make: make$2
};

export {
  make,
  Header,
  Title,
}
/* make Not a pure module */
